module.exports = __webpack_public_path__ + "img/illustration-step-1-01.ccfe7a7c.svg";